const MemberCardHandler = (stateMemberCard, setMemberCard) => {
  return {
    handleMouseEnter: () => {
      setMemberCard("isHovered", true);
    },

    handleMouseLeave: () => {
      setMemberCard("isHovered", false);
    },

    getIcon: () => {
      // Return appropriate icon based on title
      return "person";
    },
  };
};

export default MemberCardHandler;
